import i18n from 'i18next'
import { reactI18nextModule } from 'react-i18next'

import en from './i18n/en'
import fr from './i18n/fr'
import nl from './i18n/nl'
import de from './i18n/de'
import cn from './i18n/cn'
import it from './i18n/it'

i18n
  .use(reactI18nextModule)
  .init({
    fallbackLng: 'en',

    interpolation: { excapeValue: false }, // Not needed for react

    react: {
      wait: false,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      nsMode: 'default'
    },

    resources: { en, fr, nl, de, cn, it }
  })

export default i18n



// WEBPACK FOOTER //
// ./src/config/i18n.js